<template>
  <section id="organizationSetting" class="content">
    <div class="settings">
      <div class="settingsMenu">
        <li :class="{active: selectedTab === 'basic'}" v-on:click="selectTab('basic')">
          <h4>Basic Settings</h4>
          <p>Site name, description, keyword, etc.</p>
        </li>
        <li :class="{active: selectedTab === 'modal'}" v-on:click="selectTab('modal')">
          <h4>Welcome Modal</h4>
          <p>Modal when user first time open the site.</p>
        </li>
        <li :class="{active: selectedTab === 'maintenance'}" v-on:click="selectTab('maintenance')">
          <h4>Maintenance</h4>
          <p>Set or unset under maintenance mode.</p>
        </li>
        <li :class="{active: selectedTab === 'webmaster'}" v-on:click="selectTab('webmaster')">
          <h4>Webmaster & Analityc</h4>
          <p>Google analytics, and any other header tags.</p>
        </li>
        <li :class="{active: selectedTab === 'social'}" v-on:click="selectTab('social')">
          <h4>Social Media</h4>
          <p>Link to social media if any.</p>
        </li>
      </div>
      <div class="settingsContent" v-if="editData">
        <h2>Basic Settings</h2>

        <div class="ogrInfoCnt" v-if="selectedTab === 'basic'">

          <div :class="{ogrInfoItem: true, editing: basic.site_name.editing}">
            <h4>Site Name</h4>
            <p v-if="editData.site_name != ''">{{editData.site_name}}</p>
            <p v-else>-</p>
            <div class="hint">Displayed in title meta. Recomended 78 characters.</div>
            <div class="edit" v-on:click="basic.site_name.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Site Name"
                  v-model="basic.site_name.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('basic', 'site_name')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: basic.site_description.editing}">
            <h4>Site Description</h4>
            <p v-if="editData.site_description != ''">{{editData.site_description}}</p>
            <p v-else>-</p>
            <div class="hint">
              Displayed in description meta tag. Recomended 170 - 172 characters.
            </div>
            <div class="edit" v-on:click="basic.site_description.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <textarea class="field" placeholder="Site Description..." rows="4"
                  v-model="basic.site_description.model"></textarea>
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('basic', 'site_description')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: basic.keywords.editing}">
            <h4>Keywords</h4>
            <p v-if="editData.keywords != ''">{{editData.keywords}}</p>
            <p v-else>-</p>
            <div class="hint">Keywords for search engine optimization,
              separate each keyword by comma.</div>
            <div class="edit" v-on:click="basic.keywords.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <textarea class="field" placeholder="Site Keywords..." rows="3"
                  v-model="basic.keywords.model"></textarea>
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('basic', 'keywords')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true}">
            <h4>Share Image</h4>
            <div v-if="editData.share_image" class="shareImg"
              :style="{'background-image': `url(${editData.share_image.imageLg})`}"
              v-on:click="changeShareImg">
            </div>
            <p v-else>-</p>
            <div class="hint">
              Thumbnail image for when site is shared in social media
              like twitter and facebook.
            </div>
            <div class="edit" v-on:click="changeShareImg">
              <img src="../assets/edit-icon.png"> Edit
            </div>
          </div>

        </div>
        <div class="ogrInfoCnt" v-if="selectedTab === 'modal'">

          <div :class="{ogrInfoItem: true, editing: modal.enable_contest.editing}">
            <h4>Modal Enabled</h4>
            <p v-if="editData.enable_contest === 1">Yes</p>
            <p v-else>No</p>
            <div class="hint">Display modal when user first time visited site.
              Modal will not displayed in the next visit.<br />
              To preview modal in front end, clear cookie and refresh.</div>
            <div class="edit" v-on:click="modal.enable_contest.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <div :class="{switch: true, on: modal.enable_contest.model === 1}"
                  v-on:click="changeModalEnabled">
                  <div class="switchHandle"></div>
                </div>
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('modal', 'enable_contest')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true}">
            <h4>Modal Background</h4>
            <div v-if="editData.modal_bg" class="shareImg"
              v-on:click="changeModalBg"
              :style="{'background-image': `url(${editData.modal_bg.imageLg})`}">
            </div>
            <p v-else>-</p>
            <div class="edit" v-on:click="changeModalBg">
              <img src="../assets/edit-icon.png"> Edit
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: modal.modal_title.editing}">
            <h4>Modal Title</h4>
            <p v-if="editData.modal_title != ''">{{editData.modal_title}}</p>
            <p v-else>-</p>
            <div class="edit" v-on:click="modal.modal_title.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Modal title..."
                  v-model="modal.modal_title.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('modal', 'modal_title')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: modal.modal_description.editing}">
            <h4>Modal description</h4>
            <p v-if="editData.modal_description != ''">{{editData.modal_description}}</p>
            <p v-else>-</p>
            <div class="edit" v-on:click="modal.modal_description.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <textarea rows="4" class="field"
                  placeholder="Modal description..."
                  v-model="modal.modal_description.model"></textarea>
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('modal', 'modal_description')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: modal.modal_font_color.editing}">
            <h4>Font Color</h4>
            <p v-if="editData.modal_font_color != ''">
              {{editData.modal_font_color}}
            </p>
            <p v-else>-</p>
            <div class="hint">Font color for title and description (#hexadecimal),
              if blank will use default #444444.</div>
            <div class="edit" v-on:click="modal.modal_font_color.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Font color"
                  v-model="modal.modal_font_color.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('modal', 'modal_font_color')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: modal.modal_uri.editing}">
            <h4>Button Url</h4>
            <p v-if="editData.modal_uri != ''">{{editData.modal_uri}}</p>
            <p v-else>-</p>
            <div class="hint">Where will redirect when modal button clicked.</div>
            <div class="edit" v-on:click="modal.modal_uri.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Button url..."
                  v-model="modal.modal_uri.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('modal', 'modal_uri')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: modal.modal_btn_label.editing}">
            <h4>Button Label</h4>
            <p v-if="editData.modal_btn_label != ''">
              {{editData.modal_btn_label}}
            </p>
            <p v-else>-</p>
            <div class="edit" v-on:click="modal.modal_btn_label.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Modal button label"
                  v-model="modal.modal_btn_label.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('modal', 'modal_btn_label')">Cancel</button>
              </form>
            </div>
          </div>

        </div>
        <div class="ogrInfoCnt" v-if="selectedTab === 'maintenance'">

          <div :class="{ogrInfoItem: true, editing: maintenance.under_maintenance.editing}">
            <h4>Site is under maintennance?</h4>
            <p v-if="editData.under_maintenance === 1">Yes</p>
            <p v-else>No</p>
            <div class="hint">Web will display under maintenance page.</div>
            <a href="/maintenance?preview=true" target="_blank" class="btn btnPrimary btnPreview">
              Preview maintenance page</a>
            <div class="edit" v-on:click="maintenance.under_maintenance.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <div :class="{switch: true, on: maintenance.under_maintenance.model === 1}"
                  v-on:click="changeMaintenance">
                  <div class="switchHandle"></div>
                </div>
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('maintenance', 'under_maintenance')">Cancel</button>
              </form>
            </div>
          </div>

        </div>
        <div class="ogrInfoCnt" v-if="selectedTab === 'webmaster'">

          <div :class="{ogrInfoItem: true, editing: webmaster.google_webmaster.editing}">
            <h4>Google Webmaster</h4>
            <p v-if="editData.google_webmaster != ''">{{editData.google_webmaster}}</p>
            <p v-else>-</p>
            <div class="hint">Google webmaster meta tag.</div>
            <div class="edit" v-on:click="webmaster.google_webmaster.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Google webmaster"
                  v-model="webmaster.google_webmaster.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('webmaster', 'google_webmaster')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: webmaster.google_analityc.editing}">
            <h4>Google Analityc ID</h4>
            <p v-if="editData.google_analityc != ''">{{editData.google_analityc}}</p>
            <p v-else>-</p>
            <div class="hint">Google analityc tracking id. Example: <b>UA-60236868-2</b></div>
            <div class="edit" v-on:click="webmaster.google_analityc.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Google analityc"
                  v-model="webmaster.google_analityc.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('webmaster', 'google_analityc')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: webmaster.bing_webmaster.editing}">
            <h4>Bing Webmaster</h4>
            <p v-if="editData.bing_webmaster != ''">{{editData.bing_webmaster}}</p>
            <p v-else>-</p>
            <div class="edit" v-on:click="webmaster.bing_webmaster.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Bing webmaster"
                  v-model="webmaster.bing_webmaster.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('webmaster', 'bing_webmaster')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: webmaster.header_tag.editing}">
            <h4>Header Tag</h4>
            <p v-if="editData.header_tag != ''" class="headerTag">
              {{editData.header_tag}}</p>
            <p v-else>-</p>
            <div class="hint">Put header tag like google tag manager, fb pixel, etc here.</div>
            <div class="edit" v-on:click="webmaster.header_tag.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <textarea rows="12" class="field"
                  placeholder="Header tag..."
                  v-model="webmaster.header_tag.model"></textarea>
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('webmaster', 'header_tag')">Cancel</button>
              </form>
            </div>
          </div>

        </div>
        <div class="ogrInfoCnt" v-if="selectedTab === 'social'">

          <div :class="{ogrInfoItem: true, editing: social.facebook_url.editing}">
            <h4>Facebook</h4>
            <p v-if="editData.facebook_url != ''">{{editData.facebook_url}}</p>
            <p v-else>-</p>
            <div class="hint">Full url to facebook page.</div>
            <div class="edit" v-on:click="social.facebook_url.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Facebook url..."
                  v-model="social.facebook_url.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('social', 'facebook_url')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: social.twitter_url.editing}">
            <h4>Twitter</h4>
            <p v-if="editData.twitter_url != ''">{{editData.twitter_url}}</p>
            <p v-else>-</p>
            <div class="hint">Url to Twitter profile.</div>
            <div class="edit" v-on:click="social.twitter_url.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Twitter url..."
                  v-model="social.twitter_url.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('social', 'twitter_url')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: social.youtube_url.editing}">
            <h4>Youtube</h4>
            <p v-if="editData.youtube_url != ''">{{editData.youtube_url}}</p>
            <p v-else>-</p>
            <div class="hint">Youtube channel url.</div>
            <div class="edit" v-on:click="social.youtube_url.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Youtube channel url..."
                  v-model="social.youtube_url.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('social', 'youtube_url')">Cancel</button>
              </form>
            </div>
          </div>

          <div :class="{ogrInfoItem: true, editing: social.instagram_url.editing}">
            <h4>Instagram</h4>
            <p v-if="editData.instagram_url != ''">{{editData.instagram_url}}</p>
            <p v-else>-</p>
            <div class="hint">ink to instagram profile will be displayed in menu.</div>
            <div class="edit" v-on:click="social.instagram_url.editing = true">
              <img src="../assets/edit-icon.png"> Edit
            </div>
            <div class="fieldGroup">
              <form v-on:submit.prevent="saveChanges">
                <input type="text" class="field"
                  placeholder="Instagram url..."
                  v-model="social.instagram_url.model">
                <button class="btn btnPrimary">Save</button>
                <button class="btn btnSecondary" type="button"
                  v-on:click="cancelEditing('social', 'instagram_url')">Cancel</button>
              </form>
            </div>
          </div>


        </div>
      </div>
    </div>

    <Snackbar ref="snackbar"/>
    <MediaSelector ref="mediaSelector"/>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Snackbar from '@/components/Snackbar.vue';
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  name: 'home',
  components: {
    Snackbar, MediaSelector,
  },
  data() {
    return {
      selectedTab: 'basic',
      editData: null,
      basic: {
        site_name: {
          model: '',
          editing: false,
        },
        site_description: {
          model: '',
          editing: false,
        },
        keywords: {
          model: '',
          editing: false,
        },
        share_image: {
          model: null,
          editing: false,
        },
      },
      modal: {
        enable_contest: {
          model: null,
          editing: false,
        },
        modal_bg: {
          model: null,
          editing: false,
        },
        modal_title: {
          model: '',
          editing: false,
        },
        modal_description: {
          model: '',
          editing: false,
        },
        modal_font_color: {
          model: '',
          editing: false,
        },
        modal_uri: {
          model: '',
          editing: false,
        },
        modal_btn_label: {
          model: '',
          editing: false,
        },
      },
      maintenance: {
        under_maintenance: {
          model: null,
          editing: false,
        },
      },
      webmaster: {
        google_webmaster: {
          model: null,
          editing: false,
        },
        google_analityc: {
          model: null,
          editing: false,
        },
        bing_webmaster: {
          model: null,
          editing: false,
        },
        header_tag: {
          model: null,
          editing: false,
        },
      },
      social: {
        facebook_url: {
          model: null,
          editing: false,
        },
        twitter_url: {
          model: null,
          editing: false,
        },
        youtube_url: {
          model: null,
          editing: false,
        },
        instagram_url: {
          model: null,
          editing: false,
        },
      },
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    selectTab(tab) {
      this.selectedTab = tab;
      const newUri = `${process.env.BASE_URL}settings?tab=${tab}`;
      window.history.replaceState({}, tab, newUri);
    },
    changeModalEnabled() {
      this.modal.enable_contest.model = (this.modal.enable_contest.model === 1) ? 0 : 1;
    },
    changeMaintenance() {
      this.maintenance.under_maintenance.model = (this.maintenance.under_maintenance.model
        === 1) ? 0 : 1;
    },
    changeShareImg() {
      this.$refs.mediaSelector.open({}, (b, media) => {
        if (!b) return;
        this.editData.share_image = media;
        this.saveChanges();
      });
    },
    changeModalBg() {
      this.$refs.mediaSelector.open({}, (b, media) => {
        if (!b) return;
        this.editData.modal_bg = media;
        this.saveChanges();
      });
    },
    fieldChanged(field) {
      // this.form[field].error = null;
    },
    cancelEditing(x, y) {
      this[x][y].editing = false;
      this[x][y].model = this.editData[y];
    },
    saveChanges() {
      const formData = {
        id: this.editData.id,

        site_name: this.basic.site_name.model,
        site_description: this.basic.site_description.model,
        keywords: this.basic.keywords.model,
        share_image: this.editData.share_image.id,

        enable_contest: this.modal.enable_contest.model,
        modal_bg: this.editData.modal_bg.id,
        modal_title: this.modal.modal_title.model,
        modal_description: this.modal.modal_description.model,
        modal_font_color: this.modal.modal_font_color.model,
        modal_uri: this.modal.modal_uri.model,
        modal_btn_label: this.modal.modal_btn_label.model,

        under_maintenance: this.maintenance.under_maintenance.model,

        google_webmaster: this.webmaster.google_webmaster.model,
        google_analityc: this.webmaster.google_analityc.model,
        bing_webmaster: this.webmaster.bing_webmaster.model,
        header_tag: this.webmaster.header_tag.model,

        facebook_url: this.social.facebook_url.model,
        twitter_url: this.social.twitter_url.model,
        youtube_url: this.social.youtube_url.model,
        instagram_url: this.social.instagram_url.model,
      };

      /**
       * Set editing to false
       *
       */
      this.basic.site_name.editing = false;
      this.basic.site_description.editing = false;
      this.basic.keywords.editing = false;

      this.modal.enable_contest.editing = false;
      this.modal.modal_title.editing = false;
      this.modal.modal_description.editing = false;
      this.modal.modal_font_color.editing = false;
      this.modal.modal_uri.editing = false;
      this.modal.modal_btn_label.editing = false;

      this.maintenance.under_maintenance.editing = false;

      this.webmaster.google_webmaster.editing = false;
      this.webmaster.google_analityc.editing = false;
      this.webmaster.bing_webmaster.editing = false;
      this.webmaster.header_tag.editing = false;

      this.social.facebook_url.editing = false;
      this.social.twitter_url.editing = false;
      this.social.youtube_url.editing = false;
      this.social.instagram_url.editing = false;

      /**
       * Update value
       *
       */
      this.editData.site_name = formData.site_name;
      this.editData.site_description = formData.site_description;
      this.editData.keywords = formData.keywords;

      this.editData.enable_contest = formData.enable_contest;
      this.editData.modal_title = formData.modal_title;
      this.editData.modal_description = formData.modal_description;
      this.editData.modal_font_color = formData.modal_font_color;
      this.editData.modal_uri = formData.modal_uri;
      this.editData.modal_btn_label = formData.modal_btn_label;

      this.editData.under_maintenance = formData.under_maintenance;

      this.editData.google_webmaster = formData.google_webmaster;
      this.editData.google_analityc = formData.google_analityc;
      this.editData.bing_webmaster = formData.bing_webmaster;
      this.editData.header_tag = formData.header_tag;

      this.editData.facebook_url = formData.facebook_url;
      this.editData.twitter_url = formData.twitter_url;
      this.editData.youtube_url = formData.youtube_url;
      this.editData.instagram_url = formData.instagram_url;

      this.$http.post(this.$config.uri('misc/settings'), formData).then((r) => {
        if (r.data.status !== 200) {
          // Display error
          return;
        }
        this.$refs.snackbar.open({ content: 'Changes has been saved.' });
      });
    },
  },
  mounted() {
    this.chTitle('Web Config');
    this.chCGB(true);
    this.selectedTab = (this.$route.query && this.$route.query.tab)
      ? this.$route.query.tab : 'basic';
    this.$http.get(this.$config.uri('misc/settings')).then((r) => {
      if (r.data.status !== 200) {
        // Dispay error
        return;
      }
      this.editData = r.data.data;
    });
    this.$http.get(this.$config.uri('misc/settings')).then((r) => {
      if (r.data.status !== 200) {
        // Dispay error
        return;
      }
      const { data } = r.data;
      this.basic.site_name.model = data.site_name;
      this.basic.site_description.model = data.site_description;
      this.basic.keywords.model = data.keywords;

      this.modal.enable_contest.model = data.enable_contest;
      this.modal.modal_title.model = data.modal_title;
      this.modal.modal_description.model = data.modal_description;
      this.modal.modal_font_color.model = data.modal_font_color;
      this.modal.modal_uri.model = data.modal_uri;
      this.modal.modal_btn_label.model = data.modal_btn_label;

      this.maintenance.under_maintenance.model = data.under_maintenance;

      this.webmaster.google_webmaster.model = data.google_webmaster;
      this.webmaster.google_analityc.model = data.google_analityc;
      this.webmaster.bing_webmaster.model = data.bing_webmaster;
      this.webmaster.header_tag.model = data.header_tag;

      this.social.facebook_url.model = data.facebook_url;
      this.social.twitter_url.model = data.twitter_url;
      this.social.youtube_url.model = data.youtube_url;
      this.social.instagram_url.model = data.instagram_url;
    });
  },
};
</script>

<style scoped lang="scss">
.settings{
  display: flex;
  height: 100%;
  margin: 0 -30px;
  .settingsMenu{
    width: 300px;
    border-right: #eee 1px solid;
    li{
      list-style: none;
      padding: 14px 20px;
      border-bottom: #eee 1px solid;
      cursor: pointer;
      &:hover{
        background-color: #f5f5fe;
      }
      &.active{
        background-color: #c4e894;
      }
      h4{
        margin: 0;
        font-size: 18px;
        font-weight: normal;
      }
      p{
        color: #767676;
        font-size: 15px;
      }
    }
  }
  .settingsContent{
    width: calc(100% - 300px);
    box-sizing: border-box;
    height: 100%;
    overflow-y: auto;
    h2{
      border-bottom: #eee 1px solid;
      padding: 14px 20px;
      color: #767676;
      font-weight: normal;
      margin: 0;
    }
  }
}

  .orgSetting{
    max-width: 700px;
    h2{
      font-size: 30px;
      // font-weight: normal;
    }
  }
  .ogrInfoItem{
    position: relative;
    margin: 0;
    padding: 14px 120px 16px 20px;
    border-bottom: #eee 1px solid;
    .logo{
      width: 160px;
      height: 160px;
      border-radius: 50%;
      box-shadow: 2px 2px 6px rgba(0,0,0,.2);
      background-image: url(../assets/marriot-logo.jpg);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
    .shareImg{
      height: 300px;
      border-radius: 10px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      background-color: #eee;
      cursor: pointer;
      max-width: 640px;
    }
    .hint{
      color: #767676;
      font-size: 12px;
      margin-top: 4px;
    }
    h4{
      color: #767676;
      margin: 0 0 4px;
      font-weight: normal;
    }
    h4.h4logo{
      top: 90px;
    }
    p{
      margin: 0;
    }
    a.btn.btnPreview{
      display: inline-block;
      margin-top: 14px;
      font-weight: 600;
      padding: 8px 16px;
      font-size: 17px;
    }
    .fieldGroup{
      display: none;
      margin-bottom: 0;
      margin-top: 10px;
      .switch{
        width: 46px;
        height: 26px;
        margin-bottom: 20px;
        background-color: #f5f5f5;
        border: #ddd 1px solid;
        border-radius: 50px;
        cursor: pointer;
        // transition: all .2s ease;
        .switchHandle{
          width: 22px; height: 22px;
          margin-top: 2px; margin-right: 2px;
          background-color: #fff;
          border-radius: 50%;
          box-shadow: 2px 2px 3px rgba(0,0,0,.2);
          transition: all .2s ease;
          margin-left: 2px;
        }
        &.on{
          background-color: #0557d8;
          .switchHandle{
            margin-left: 22px;
          }
        }
      }
      .fieldError{
        margin-bottom: 10px;
      }
      .field{
        font-size: 16px;
        margin-bottom: 10px;
        padding: 8px 12px;
      }
      .field.hasError{
        border-color: red;
        margin-bottom: 0;
      }
      .btn{
        margin-right: 5px;
        padding: 9px 24px 7px;
        font-size: 16px;
      }
    }
    .edit{
      color: #0747a6;
      font-weight: bold;
      position: absolute;
      right: 20px;
      top: 16px;
      padding: 4px 8px 5px;
      border-radius: 30px;
      cursor: pointer;
      img{
        height: 16px;
        margin: 2px 0 -2px;
      }
    }
    .edit.editLogo{
      top: 86px;
      left: 115px;
    }
    .edit:hover{
      background: #eee;
    }
  }
  .ogrInfoItem.editing{
    .btn.btnPreview{
      display: none;
    }
    .edit, p, .aboutContent{
      display: none;
    }
    .fieldGroup{
      display: block;
    }
  }
</style>
